// AI Generated Test
import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { PageFixAccessibilityConfigService } from '@client/app/modules/page-fix/services/page-fix-accessibility-config/page-fix-accessibility-config.service';

@Component({
    selector: 'page-fix-changeset-accessibility',
    standalone: false,
    template: `
        <span class="label label-info">
            {{ getChangeDescription() }}
        </span>
        <span class="fas fa-comment text-grey"
              *ngIf="hasDataOnTarget()"
              [ngbPopover]="popoverTemplate"
              triggers="click"
              placement="bottom-left"
              popoverClass="popover-bs3 monsido-card text-ellipsis"
              [animation]="false"
              autoClose="outside"
              aria-hidden="true">
        </span>

        <ng-template #popoverTemplate>
            <div class="d-flex align-items-center popover-title">
                <div>
                    <h3 class="font-weight-400 ml-1 text-black" translate>Changes added</h3>
                </div>
            </div>
            <div class="popover-content text-grey">
                <p *ngFor="let target of parseTargetCollection(); let last = last"
                   [class.mb-0]="last"
                   [class.pb-0]="last">
                    {{ target }}
                </p>
            </div>
        </ng-template>
    `,
})
export class PageFixChangesetAccessibilityComponent implements OnInit {
    @Input() data: any;

    constructor (
        private translateService: TranslateService,
        private pageFixAccessibilityConfigService: PageFixAccessibilityConfigService,
    ) {}

    ngOnInit (): void {
        this.getChangeDescription();
    }

    hasDataOnTarget (): boolean {
        return this.data && this.data.change.target;
    }

    parseTargetCollection (): string[] {
        return JSON.parse(this.data.change.target);
    }

    getChangeDescription (): string {
        return this.getTranslation();
    }

    private getTranslation (): string {
        const checkConfig = this.pageFixAccessibilityConfigService.getConfig()[this.data.change.check_id];
        const scopes = {
            value: this.data.change.value,
        };

        if (checkConfig) {
            return this.translateService.getString(checkConfig.translation, scopes);
        }

        return this.data.change.value;
    }
}
